import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { useMemo as i, createElement as x } from "react";
import a from "../../atoms/Badge/Badge.js";
import h from "../../atoms/Tooltip/Tooltip.js";
const v = ({
  size: s = "small",
  testId: p,
  badges: r,
  max: t,
  tooltipPlacement: c = "bottom"
}) => {
  const m = i(
    () => r.length > Number(t) ? r.slice(0, t) : r,
    [r, t]
  ), l = i(
    () => r.length > Number(t) ? r.slice(t) : [],
    [r, t]
  ), d = i(() => /* @__PURE__ */ e.jsxs("div", { className: "flex gap-050", children: [
    m.map((n, o) => /* @__PURE__ */ x(
      a,
      {
        ...n,
        key: o,
        size: s
      }
    )),
    l.length > 0 && /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      h,
      {
        placement: c,
        behavior: "popover",
        trigger: /* @__PURE__ */ e.jsx(
          a,
          {
            variant: "tinted",
            color: "gray",
            label: `+${l.length}`,
            size: s
          }
        ),
        children: /* @__PURE__ */ e.jsx("div", { className: "flex flex-wrap justify-center items-center gap-075 w-[220px]", children: l.map((n, o) => /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "text-wrap",
            children: /* @__PURE__ */ e.jsx(
              a,
              {
                className: "max-w-[200px]",
                ...n,
                size: s
              }
            )
          },
          o
        )) })
      }
    ) })
  ] }), [m, l, s, c]);
  return /* @__PURE__ */ e.jsx("div", { "data-testid": p, children: d });
};
export {
  v as default
};
//# sourceMappingURL=BadgeGroup.js.map
